import { replaceOrigin } from "@ey/canvascoreservices/DeepLink";
import Env from "../util/env.js";

/**
 * These are the mapping rules for deep links used in Hercules.
 * Each rule defines how to map a deep link url (/redirect?topic=...) to a specific Hercules/Kronos url.
 *
 * So far, we have two types of rules:
 *
 * - queryStringTopic: Matches a specific topic and a list of parameters in the query string,
 *   and maps it using a template URL string or a transform function.
 * - queryStringParams: Similar to queryStringTopic, but matches any combination of parameters
 *   in the query string, without a specific topic parameter.
 * - asyncCheck: An asynchronous function that can perform complex logic, including fetching data
 *   from the Redux store, to determine the mapped URL.
 * - replaceOrigin: A simple rule that replaces the origin of the URL. It can be an origin string
 *   or a function that computes the origin. This is useful for redirecting the whole request
 *   to a different app that understands the same deep link structure (eg, Hercules).
 *
 * In asyncCheck rules, you have access to helper functions to interact with the Redux store and any
 * other helpers defined in getStoreHelpers and getUIHelpers functions (MappingHelpers.js).
 *
 * Since mapping rules are implemented as functions, they can be composed to create more complex rules
 * without having to duplicate code.
 *
 * In asyncCheck rules or queryStringParams/queryStringTopic transform functions, you can produce
 * side effects like opening a modal or a frame, if these actions aren't mappable as URLs.
 *
*/
export const rules = [
	replaceOrigin({
		origin: Env.getURL("hercules_web")
	})
];

/**
 * These are helpers that provide UI side-effects to mapping rules.
 * Some of the mapping rules do not map to URLs, but instead perform
 * side effects like opening a modal or a frame.
 *
 * For now, Kronos doesn't need helper functions, but we'll leave this
 * here anyways.
 */
export const helpers = {
};